export let EntriFlowStatus = /*#__PURE__*/function (EntriFlowStatus) {
  EntriFlowStatus["success"] = "success";
  EntriFlowStatus["manual"] = "manual";
  EntriFlowStatus["abort"] = "abort";
  EntriFlowStatus["error"] = "error";
  return EntriFlowStatus;
}({});

/**
 * Classifies why an Entri flow resolved to a manual result. This lets consumers
 * distinguish a genuine setup failure (`setupFailed`) from a deliberate manual
 * fallback (`userChoseManual` / not eligible) without sniffing the free-text
 * `error` message.
 */
export let EntriFlowErrorType = /*#__PURE__*/function (EntriFlowErrorType) {
  EntriFlowErrorType["setupFailed"] = "setupFailed";
  EntriFlowErrorType["userChoseManual"] = "userChoseManual";
  return EntriFlowErrorType;
}({});
export let EntriSteps = /*#__PURE__*/function (EntriSteps) {
  EntriSteps["INITIAL"] = "INITIAL";
  EntriSteps["ENTER_DOMAIN"] = "ENTER_DOMAIN";
  EntriSteps["DOMAIN_ANALYSIS"] = "DOMAIN_ANALYSIS";
  EntriSteps["DOMAIN_SETUP"] = "DOMAIN_SETUP";
  EntriSteps["IN_PROGRESS"] = "IN_PROGRESS";
  EntriSteps["EXISTING_RECORDS"] = "EXISTING_RECORDS";
  EntriSteps["LOGIN"] = "LOGIN";
  EntriSteps["MANUAL_CONFIGURATION"] = "MANUAL_CONFIGURATION";
  EntriSteps["PROVIDER_MANUAL_SELECTION"] = "PROVIDER_MANUAL_SELECTION";
  EntriSteps["EXIT_WITH_ERROR"] = "EXIT_WITH_ERROR";
  EntriSteps["DKIM_SETUP"] = "DKIM_SETUP";
  EntriSteps["FINISHED_SUCCESSFULLY"] = "FINISHED_SUCCESSFULLY";
  EntriSteps["FINISHED_SUCCESSFULLY_MANUAL"] = "FINISHED_SUCCESSFULLY_MANUAL";
  return EntriSteps;
}({}); //	The user has successfully configured their domain using the manual flow.
export let EntriEvents = /*#__PURE__*/function (EntriEvents) {
  EntriEvents["onEntriClose"] = "onEntriClose";
  EntriEvents["onEntriStepChange"] = "onEntriStepChange";
  EntriEvents["onEntriManualSetupDocumentationClick"] = "onEntriManualSetupDocumentationClick";
  return EntriEvents;
}({});
//# sourceMappingURL=entri.js.map